import React, { Component } from 'react';
import { Table, Button } from 'react-bootstrap'
import Api from '../../../../Global/Modules/Api'
import VerklaringenToevoegen from '../../../Modules/Leden/Lid/Werkervaring/VerklaringenToevoegen'

class Verklaringen extends Component {
    constructor() {
        super();
        this.handlePaginationClick = this.handlePaginationClick.bind(this)
        this.handleClickVerk = this.handleClickVerk.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.getKennis = this.getKennis.bind(this)
        this.state = {
            kennis: [],
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            },
            currentFetchUrl: '', // To know where to fetch (to refresh companies) if a company is deleted
        }
    }
    handleClickVerk(e) {
        var url = "api/members/" + e + "/getVerk";
        Api.GetApiDownload(url)
    }
    componentWillMount() {
        const FETCH_URL = "api/members/" + this.props.id + "/explanations"
        this.setState({ currentFetchUrl: FETCH_URL })
        this.getKennis(FETCH_URL)
    }
    handlePaginationClick(e) {
        const FETCH_URL3 = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.setState({ currentFetchUrl: FETCH_URL3 })
        this.getKennis(FETCH_URL3)
    }

    handleDelete = id => event => {
        event.preventDefault()
        const FETCH_URL_DELETE = `api/members/${id}/explanation`
        if (window.confirm('Are you sure you wish to delete this item?')) {
            Api.print(`DELETE ${FETCH_URL_DELETE}`)
            Api.DeleteApi(FETCH_URL_DELETE).then(response => {
                Api.print(`Response delete company with id: ${id}`)
                Api.print(response)
                this.getKennis(this.state.currentFetchUrl) // Update the companies list
            })
        }
    }

    getKennis(fetchUrl) {
        Api.GetTableApi(fetchUrl, this.handlePaginationClick).then(response => {

            this.setState({ pagination: response.pagination }) // Pagination object 
            return response.data.json() // Data -> companies object
        }).then(objectData => {
            if (objectData !== undefined)
                this.setState({ kennis: objectData }); // Companies object
        })
    }
    render() {
        let kennis = this.state.kennis
        return (
            <div>
                <h5><strong>Verklaringen</strong></h5>
                <VerklaringenToevoegen id={this.props.id} />
                <div>
                    <div>Resultaten  {(this.state.pagination.pageSize == '0' || this.state.pagination.pageSize > this.state.pagination.totalCount) ? this.state.pagination.totalCount : this.state.pagination.pageSize} van {this.state.pagination.totalCount}</div>
                    <Table responsive striped bordered hover className="text-center">
                        <thead>
                            <tr>
                                <th>datum</th>
                                <th>bekijk</th>
                                <th>verwijder</th>
                            </tr>
                        </thead>
                        <tbody>
                            {kennis !== undefined ? kennis.map((comp) => {
                                //let editUrl = `/admin/kennis/bijeenkomst/bewerken/${comp.id}`
                                return (<tr key={comp.id}>
                                    <td>{Api.formatDateAndTime(comp.dateUpdatedUtc)}</td>
                                    <td><a onClick={() => this.handleClickVerk(comp.id)} target="_blank" title={"Bekijk verklaring van " + Api.formatDateAndTime(comp.dateCreatedUtc)}>bekijk<br /></a></td>
                                    <td><Button bsSize="xsmall" className="delete" onClick={this.handleDelete(comp.id)}>
                                        verwijder
                                    </Button></td>
                                </tr >)
                            }) : null}
                        </tbody>
                    </Table>
                    <div className="paginationStyling">
                        <div style={{ float: 'left' }}>
                            {this.state.pagination.prevButton}
                        </div>
                        <div style={{ float: 'center' }}>
                            Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                        </div>
                        <div style={{ float: 'right' }}>
                            {this.state.pagination.nextButton}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Verklaringen;




// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Verklaringen.js